import { useForm, Link, usePage, Head } from '@inertiajs/react'
import Logo from '@/components/Logo'
import GoogleOAuthButton from '@/components/GoogleOAuthButton'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { FormEvent, ReactNode } from 'react'

export default function UserSignIn() {
  const { errors } = usePage<{ errors: Record<string, string> }>().props
  const { data, setData, post, processing } = useForm({
    email: '',
    password: '',
  })

  function submit(e: FormEvent) {
    e.preventDefault()
    post('/users/sign_in')
  }

  return (
    <>
      <Head title="Sign In" />
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-accent/10 to-primary/5 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
      <Card>
        <CardHeader className="text-center">
          <CardTitle className="text-3xl font-semibold">Sign in to Gala Season</CardTitle>
          <CardDescription>Welcome back, philanthropist</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <GoogleOAuthButton accountType="user" />
          <div className="relative">
            <Separator />
            <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-card px-2 text-sm text-muted-foreground">
              or
            </span>
          </div>
          <form onSubmit={submit} className="space-y-4">
            {errors.base && (
              <p className="text-base text-destructive">{errors.base}</p>
            )}

            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={data.email}
                onChange={e => setData('email', e.target.value)}
                autoComplete="email"
                autoFocus
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={data.password}
                onChange={e => setData('password', e.target.value)}
                autoComplete="current-password"
              />
            </div>

            <Button type="submit" className="w-full" disabled={processing}>
              Sign In
            </Button>
          </form>
        </CardContent>
        <CardFooter className="flex flex-col gap-2 text-center text-base">
          <p>
            <Link href="/users/password_resets/new" className="underline underline-offset-4 hover:text-primary">
              Forgot your password?
            </Link>
          </p>
          <p>
            Don't have an account?{' '}
            <Link href="/users/sign_up" className="underline underline-offset-4 hover:text-primary">
              Sign up
            </Link>
          </p>
          <p>
            <Link href="/organizations/sign_in" className="underline underline-offset-4 hover:text-primary">
              Are you an organization?
            </Link>
          </p>
        </CardFooter>
      </Card>
      </div>
    </div>
    </>
  )
}

UserSignIn.layout = (page: ReactNode) => page
